module.exports = __webpack_public_path__ + "static/media/bg3.2b81ca2d.png";